import React from 'react';
import { Link } from 'react-router-dom';

const KnowledgeCenterArticleSection = ({ __type__, ...section }) => {
  if (__type__ === 'textSection') {
    const { textSection } = section || {};
    if (!textSection) return false;
    return (
      <div className="section-text">
        <p dangerouslySetInnerHTML={{ __html: textSection }}>
        </p>
      </div>
    );
  }

  if (__type__ === 'headerSection') {
    const { headerSection } = section || {};
    if (!headerSection) return false;
    return (
      <div className="section-header">
        <h3>
          {headerSection}
        </h3>
      </div>
    );
  }

  if (__type__ === 'imageSection') {
    const { imageSection } = section || {};
    if (!imageSection) return false;
    const { href } = imageSection || {};
    return (
      <div className="section-image">
        <img src={`${href}`} alt="Image" />
      </div>
    );
  }

  if (__type__ === 'fileSection') {
    const { file, text } = section || {};
    if (!file) return false;
    const { href, filename } = file || {};
    return (
      <div className="section-internal-link">
        <a href={`${href}`} download>{text || filename}</a>
      </div>
    );
  }

  if (__type__ === 'internalLink') {
    const {
      text,
      url
    } = section || {};
    const { data } = url || {};
    const { slug } = data || {};
    return (
      <div className="section-internal-link">
        <Link to={`/knowledge-center/article/${slug}`}>{text}</Link>
      </div>
    );
  }

  if (__type__ === 'externalLink') {
    const {
      text,
      url
    } = section || {};
    return (
      <div className="section-external-link">
        <a href={url} target="_blank">
          {text}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            x="0px"
            y="0px"
            viewBox="0 0 65 65"
            style={{ enableBackground: 'new 0 0 64 64' }}
          >
            <path
              d="M22,43V23h4.8v-2H21c-0.6,0-1,0.4-1,1v22c0,0.6,0.4,1,1,1h22c0.6,0,1-0.4,1-1v-5.8h-2V43H22z"
            />
            <path
              d="M42.1,20.7l-9.4,9.4l1.4,1.4l9.5-9.5v3.2h2v-6.7h-6.7v2H42.1z"
            />
          </svg>
        </a>
      </div>
    );
  }

  if (__type__ === 'video') {
    const {
      video
    } = section || {};
    return (
      <div style={{ textAlign: 'center' }}>
        <iframe
          width="560"
          height="315"
          src={video}
          frameBorder="0"
          allow="autoplay;
          encrypted-media"
          allowFullScreen
        ></iframe>
      </div>
    )
  }

  return false;
};

export default KnowledgeCenterArticleSection;



// WEBPACK FOOTER //
// ./src/components/routes/KnowledgeCenterArticleSection.js